<template>
	<div class="advocacy-standard">
		<section class="section filter-section" v-bind:class="contentBackground()">
			<filter-sidebar v-if="filters" v-bind:filters="filters"></filter-sidebar>
		</section>

		<section class="cards card--list section">
			<div class="global-container">
				<div class="list-row row">
					<div class="advocacy-items-wrapper items-wrapper" v-if="listing.length > 0">
						<fragment>
							<advocacy-alert-item v-for="(item, index) in listing"
												 v-bind:item="item"
												 v-bind:displaySummary="displaySummary"
												 v-bind:key="item.DetailID"></advocacy-alert-item>
						</fragment>

						<section class="padding-top padding-bottom pagination" v-if="pagination && pagination.totalPages > 1" v-bind:class="contentBackground()">
							<div class="global-container">
								<pagination></pagination>
							</div>
						</section>

					</div>

					<div class="advocacy-items-wrapper items-wrapper no-result" v-else v-bind:class="contentBackground()">
						<fragment v-if="noresultsmsg">
							<richtext-content></richtext-content>
						</fragment>
						<fragment v-else>
							<h3 class="not-found-heading h4">Sorry, no results were found matching your specifications.</h3>
							<p>Try removing some filters or searching a different term.</p>
						</fragment>
					</div>

				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import SummaryItem from '../components/listing/summary-item';
    import AdvocacyAlertItem from '../components/listing/advocacy-alert-item';
    import CardItem from '../components/listing/card-item';
	import FilterSidebar from '../components/listing/filter-sidebar';
	import advocacyAlertWidgetFilter from '../filters/advocacy-alert-widget-filter';
	import RichTextContent from '../components/layout/richtext-content';
	import * as CONST from '../utils/constants';

	export default {
		props: ['filterid', 'filtertype', 'result', 'resource', 'noresultsmsg'],
		data: function () {
			return {
                displaySummary: CONST.globalProject.DisplayListingSummary || false,
                displayCardItems: CONST.globalProject.DisplayCardItems || false,
				filters: {}
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
            'advocacy-alert-item': AdvocacyAlertItem,
            'card-item': CardItem,
			'filter-sidebar': FilterSidebar,
			'richtext-content': RichTextContent
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			if (this.filtertype == "advocacyAlertWidgetFilter") {
                this.filters = advocacyAlertWidgetFilter;
			};

			if (this.hidefilterbar == "true") {
				this.showfilters = false;
			} else {
				this.showfilters = true;
			}

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),

			showCategories: function() {
				if (this.filtertype == 'advocacyAlertWidgetFilter') {
					return true;
				}
				if (this.hidecategories) {
					return false;
				}
				return true;
			},
			contentBackground: function() {
				if (this.filtertype == 'advocacyAlertWidgetFilter') {
					return 'bg-white';
				}
				return 'bg-white';
			},
        },
    }
</script>